import { SnackbarProvider } from 'notistack';
import { type PropsWithChildren } from 'react';

import { VivaCustomSnackbar } from '../../components/snackbars/VivaCustomSnackbar';

export const VivaSnackbarProvider = ({ children }: PropsWithChildren) => (
  <SnackbarProvider
    Components={{
      success: VivaCustomSnackbar,
      error: VivaCustomSnackbar,
      info: VivaCustomSnackbar,
      warning: VivaCustomSnackbar,
    }}
    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
    autoHideDuration={3_000}
    maxSnack={5}
  >
    {children}
  </SnackbarProvider>
);
